import { cancelOnSessionChange } from './session-cancellation';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TryItService } from '@api/services/try-it.service';
import * as TryItActions from '../actions/try-it.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class TryItEffects {
  tryItProxyRequest$;
  loadRequestHistory$;

  constructor(
    private actions$: Actions,
    private tryItService: TryItService
  ) {
    this.tryItProxyRequest$ = createEffect(() =>
      this.actions$.pipe(
        ofType(TryItActions.tryItProxyRequest),
        mergeMap(({ params }) =>
          this.tryItService.tryItProxyRequest(params).pipe(
            map(response => TryItActions.tryItProxyRequestSuccess({ response })),
            catchError(error =>
              of(TryItActions.tryItProxyRequestFailure({ error: error?.message || 'Proxy request failed' }))
            ),
            cancelOnSessionChange(this.actions$)
          )
        )
      )
    );

    this.loadRequestHistory$ = createEffect(() =>
      this.actions$.pipe(
        ofType(TryItActions.loadRequestHistory),
        switchMap(({ params }) =>
          this.tryItService.tryItGetRequestHistory(params).pipe(
            map(response => TryItActions.loadRequestHistorySuccess({ 
              requests: response.requests || [] 
            })),
            catchError(error =>
              of(TryItActions.loadRequestHistoryFailure({ 
                error: error?.message || 'Failed to load request history' 
              }))
            ),
            cancelOnSessionChange(this.actions$)
          )
        )
      )
    );
  }
}
